import { render, staticRenderFns } from "./LostPasswordPage.vue?vue&type=template&id=142278b2"
import script from "./LostPasswordPage.vue?vue&type=script&lang=js"
export * from "./LostPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./LostPasswordPage.vue?vue&type=style&index=0&id=142278b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports